import Select, { SingleValue } from 'react-select';
import style from '@/modules/Note/Note.module.scss';
import { useEffect, useState } from 'react';
import styles from './ComplaintTitle.module.scss';
import { Code, CODE_SYSTEM_ICD_10, CODE_SYSTEM_ICD_10_INTERNAL, NOTE_STATUS } from '@ax/constants';
import { Loader } from '@ax/ui';
import { useAppSelector } from '@ax/redux-store';
import SelectDropdownRow from '@/components/SelectDropdownRow/index.tsx';

export interface ComplaintTitleProps {
  complaint: {
    complaintName: string;
    complaintId: number;
    section: string;
    loading?: boolean;
    codes: Partial<Code>[];
  };
  onValueChanged: (
    selectedOption: SingleValue<Partial<Code>>,
    selectedCode: Partial<Code> | null,
  ) => void;
  onDropdownOpen: () => void;
  onlyShowCodes?: boolean;
}

function isICD10Code(code: Partial<Code>) {
  return [CODE_SYSTEM_ICD_10, CODE_SYSTEM_ICD_10_INTERNAL].includes(code.codeSystem);
}

const ComplaintTitle = ({
  complaint,
  onValueChanged,
  onDropdownOpen,
  onlyShowCodes,
}: ComplaintTitleProps) => {
  const [codes, setCodes] = useState<Partial<Code>[]>(complaint.codes.filter(isICD10Code));
  const noteStatus = useAppSelector((state) => state.selectedVisit.noteStatus);
  const [selectedCode, setSelectedCode] = useState<Partial<Code> | null>(null);

  useEffect(() => {
    const transformedCodes = complaint.codes.filter(isICD10Code).map((c, index) => ({
      ...c,
      value: index,
      label: c.code !== 'NO-ICD-10-CODE' ? `${c.display} - ${c.code}` : c.display,
    }));
    setCodes(transformedCodes);
  }, [complaint]);

  useEffect(() => {
    const selectedCode = codes?.find((c) => c.status === 'ACCEPTED') || null;
    setSelectedCode(selectedCode);
  }, [codes]);

  // @ts-ignore
  return (
    <div className={styles.complaint__title__container}>
      {!onlyShowCodes && (
        <strong className={styles.complaint__title__template__name}>
          {complaint.complaintName}
        </strong>
      )}
      {complaint.loading ? (
        <Loader />
      ) : (
        <div className={styles.complaint__title__dropdown__container}>
          {codes.length > 0 && (
            <Select
              // @ts-ignore
              getOptionLabel={(option) => <SelectDropdownRow option={option} />}
              isDisabled={
                noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_MDS ||
                noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_EHR
              }
              classNames={{
                dropdownIndicator: () => {
                  return style.custom_dropdown_indicator;
                },
              }}
              onMenuOpen={() => {
                onDropdownOpen();
              }}
              value={selectedCode || codes[0]}
              classNamePrefix="select"
              onChange={(selectedOption) => {
                onValueChanged(selectedOption, selectedCode);
              }}
              options={codes}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: '#3173b1a8',
                  neutral20: '#e0e0e0',
                  neutral30: '#e0e0e0',
                },
              })}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ComplaintTitle;
